// Generated by AI on 05/27/2026
import { makeStyles } from '@material-ui/styles';
import {
    white, mineShaft, alizarinCrimson, royalblue, alabaster,
} from '../../constants/Colors';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: alabaster,
        padding: '24px',
        textAlign: 'center',
    },
    card: {
        backgroundColor: white,
        borderRadius: '8px',
        padding: '48px 32px',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    icon: {
        fontSize: '64px',
        color: alizarinCrimson,
        marginBottom: '24px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 600,
        color: mineShaft,
        marginBottom: '16px',
    },
    message: {
        fontSize: '16px',
        color: mineShaft,
        marginBottom: '8px',
        lineHeight: '1.5',
    },
    details: {
        fontSize: '14px',
        color: '#666',
        marginBottom: '32px',
        lineHeight: '1.5',
    },
    buttonContainer: {
        display: 'flex',
        gap: '16px',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    button: {
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
        },
    },
    primaryButton: {
        backgroundColor: royalblue,
        color: white,
    },
    secondaryButton: {
        backgroundColor: white,
        color: royalblue,
        border: `1px solid ${royalblue}`,
    },
    detailsToggleButton: {
        marginTop: '16px',
    },
    errorDetails: {
        marginTop: '24px',
        padding: '16px',
        backgroundColor: alabaster,
        borderRadius: '4px',
        textAlign: 'left',
        fontSize: '12px',
        fontFamily: 'monospace',
        color: '#333',
        maxHeight: '200px',
        overflow: 'auto',
        wordBreak: 'break-word',
    },
    errorMessage: {
        marginBottom: '16px',
    },
    stackTraceSection: {
        marginTop: '16px',
    },
    stackTraceLabel: {
        display: 'block',
        marginBottom: '8px',
    },
    stackTrace: {
        margin: 0,
        whiteSpace: 'pre-wrap',
    },
}));

export default useStyles;
